// Shared types for the admin live chat page and its sub-components.

export interface ChatSession {
  id: string;
  visitor_id: string;
  visitor_name: string | null;
  visitor_email: string | null;
  status: string;
  current_page: string | null;
  product_context: any;
  last_message_at: string | null;
  unread_count: number;
  taken_over_by: string | null;
  admin_name: string | null;
  last_message: string | null;
  created_at: string;
}

export interface ChatMessage {
  id: string;
  session_id: string;
  sender_type: 'visitor' | 'ai' | 'admin' | 'system';
  content: string;
  created_at: string;
  admin_name?: string;
  metadata?: any;
}

/** Segmented filter values for the session list. */
export type StatusFilter = 'all' | 'waiting' | 'admin' | 'ai';

export const displayName = (session: Pick<ChatSession, 'visitor_name' | 'visitor_id'>) =>
  session.visitor_name || `Visitor ${session.visitor_id.slice(0, 8)}`;
